export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('state');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (e) {
    return undefined;
  }
};

export const saveState = (state) => {
  try {
    const { auth } = state;
    if (auth.loggedInUser.accessToken) {
      const serializedState = JSON.stringify({
        auth,
      });
      localStorage.setItem('state', serializedState);
    }
  } catch (e) {
    // ignore errors
  }
};

export const emptyState = () => {
  localStorage.removeItem('state');
};

export const getAccessToken = () => {
  const state = loadState();
  return (
    (state
      && state.auth
      && state.auth
      && state.auth.loggedInUser
      && state.auth.loggedInUser.accessToken)
    || ''
  );
};
